<template>
  <div class="container has-text-centered">
    <img alt="logo" src="../assets/logo.png" />
    <div
      class="hero-home is-cover is-relative is-fullheight-with-navbar is-primary"
    >
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-1 has-text-grey">
            Hello, I'm
            <span class="is-family-secondary has-text-primary">Alexandre</span>
          </h1>
          <h2 class="subtitle is-5 is-uppercase">
            A
            <span class="is-family-secondary has-text-primary"
              >game developer</span
            >
            with a passion for new technologies
          </h2>
          <a class="button is-info is-outlined" href="files/resume.pdf" download
            >Download CV
          </a>
        </div>
      </div>
    </div>

    <div class="container box">
      <div class="level">
        <div class="level-item has-text-centered">
          <div>
            <p class="heading is-uppercase">Email</p>
            <a
              class="heading has-text-primary"
              href="mailto:alexandre@bravenobles.eu"
            >
              alexandre@bravenobles.eu
            </a>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading is-uppercase">GitHub</p>
            <a
              class="heading has-text-primary"
              href="https://github.com/shokkueibu"
            >
              github.com/shokkueibu
            </a>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading is-uppercase">Twitter</p>
            <a
              class="heading has-text-primary"
              href="https://twitter.com/syntactic_salt"
            >
              @syntactic_salt
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home"
};
</script>
